import type { CompanyEventsQueryParams } from '@benzinga/calendar-manager';

import type { IDateRange } from '../lib/interfaces';

export function initialCompanyEventsFetchParams(range: IDateRange | null, ticker?: string): CompanyEventsQueryParams {
  return {
    ...(range && { date_from: range.date_from ?? '', date_to: range.date_to ?? '' }),
    ...(ticker && { tickers: ticker }),
  };
}
